var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switchLink"},_vm._l((_vm.dataSwitchLinks),function(item,index){return _c('nuxt-link',{key:index,class:[
            'switchLink__link',
            { 'switchLink__link--active': _vm.isRouteActive(item.path) } ],attrs:{"to":{ path: item.path }}},[_vm._v("\n        "+_vm._s(item.text)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }